import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../../atoms/buttons/enums.js';
import { wrapRichTextTables } from '../../../utilities/dom-helpers/index.js';
import '../../../atoms/buttons/generic-button2.0/index.js';
import '../../../molecules/image-block-container/index.js';

const renderBadge = (badge) => $ `<p class="feature-card__badge">${o(badge)}</p>`;
const renderFeatureCard = (card, index) => {
    var _a, _b;
    const cardId = `feature-card-${card.id || index}`;
    const titleId = `${cardId}-title`;
    const descId = `${cardId}-desc`;
    const ctaAriaLabel = card.ctaAriaLabel || undefined;
    const ctaTarget = card.ctaTarget || '_self';
    const hasValidCta = Boolean((_a = card.ctaLabel) === null || _a === void 0 ? void 0 : _a.trim())
        && Boolean((_b = card.ctaHref) === null || _b === void 0 ? void 0 : _b.trim())
        && card.ctaHref.trim() !== '#';
    const badgesTemplate = card.badges && card.badges.length > 0
        ? $ `<div class="feature-card__badges">${card.badges.map(renderBadge)}</div>`
        : w;
    const ariaAttributes = {
        'aria-label': ctaAriaLabel,
    };
    const ctaTemplate = hasValidCta
        ? $ `<div class="feature-card__cta-group"><generic-button-updated type="primary" color="purple" styleType="light" appearance="default" label="${card.ctaLabel}" href="${card.ctaHref}" target="${ctaTarget}" .ariaList="${ariaAttributes}"></generic-button-updated></div>`
        : w;
    return $ `<article class="feature-card" id="${cardId}" data-card-index="${index}"><div class="feature-card__content">${badgesTemplate}<h3 id="${titleId}" class="feature-card__title">${o(card.title)}</h3><div id="${descId}" class="feature-card__description rte">${o(wrapRichTextTables(card.description))}</div>${ctaTemplate}</div><div class="feature-card__image-wrapper"><image-block-container src="${card.imageUrl}" alt="${card.imageAltText}" decorative="${card.imageDecorative ? 'decorative' : ''}" alignment="left" aspect-ratio="16:9" full-width></image-block-container></div></article>`;
};

export { renderFeatureCard };
